import { ISelectOption } from './selectOption.interface';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { RuleStatus } from '../api/governance/violationRule.model';
import { Label } from 'src/app/labels/englishLabels';

export const ViolationRuleStatusSelectOptions: ISelectOption[] = [
  {
    id: `${FilterTypesEnum.ViolationRuleStatus}-${RuleStatus.on}`,
    value: RuleStatus.on,
    displayName: Label.get('common.statusActive'),
    categoryName: FilterTypesEnum.ViolationRuleStatus.toString(),
    filterType: FilterTypesEnum.ViolationRuleStatus,
  },
  {
    id: `${FilterTypesEnum.ViolationRuleStatus}-${RuleStatus.off}`,
    value: RuleStatus.off,
    displayName: Label.get('common.statusInactive'),
    categoryName: FilterTypesEnum.ViolationRuleStatus.toString(),
    filterType: FilterTypesEnum.ViolationRuleStatus,
  },
];
